import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { RiskDisclosureComponent } from './risk-disclosure.component';


@NgModule({
    declarations: [
        RiskDisclosureComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule
    ],
    exports: [
        RiskDisclosureComponent
    ]
})
export class RiskDisclosureModule { }
